import Thumbnail, { ThumbnailSize } from 'components/Widget/Thumbnail';
import * as S from './styles';

interface ThumbnailStripProps {
	frameIds: string[];
	onRemove: (frameId: string) => void;
	onClick?: (frameId: string) => void;
	selectOnClick?: boolean;
}

const ThumbnailStrip = ({ frameIds, onRemove, onClick, selectOnClick }: ThumbnailStripProps) => {
	if (!frameIds.length) return null;

	return (
		<S.Base
			onWheel={(e) => {
				e.stopPropagation();
				e.currentTarget.scrollLeft += e.deltaX;
			}}
		>
			{frameIds.map((frameId) => (
				<Thumbnail
					key={frameId}
					frameId={frameId}
					onDelete={() => onRemove(frameId)}
					onClick={onClick ? () => onClick(frameId) : undefined}
					selectOnClick={selectOnClick}
					size={ThumbnailSize.CHAT}
				/>
			))}
		</S.Base>
	);
};

export default ThumbnailStrip;
